// extracted by mini-css-extract-plugin
module.exports = {"modal":"ApprovalRequestSentModal_modal__1lg2U"};